import { BANNER_MEDIA_CONFIG } from '@x/content/render/dynamic-components/banner/banner';
import { TContentMediaConfig } from '@x/content/render/types/content-media.config';

export const ACTION_GRID_MEDIA_CONFIG: TContentMediaConfig<'action', 'grid'> = {
  'action-grid': {
    ...BANNER_MEDIA_CONFIG['banner-narrow'],
  },
};
